import Service from "../../Service";

const resource = "HmnPaymentsConfirmed/";

export default {
    pagination(parameters, requestID) {
        // console.log(parameters, requestID);
        return Service.post(resource + "pagination", parameters, {
            params: { requestID },
        });
    },
    list(parameters, requestID) {
        return Service.post(resource + "list", parameters, {
            params: { requestID },
        });
    },
    typedocuments(requestID) {
        return Service.post(resource + "typedocuments", {}, {
            params: { requestID },
        });
    },
};